/**
 * Format a number as Colombian currency (COP)
 * Format: $1.234.567 (uses dots for thousands, no decimals)
 * @param value - The numeric value to format (can be number, string, null, or undefined)
 * @param includeSymbol - Whether to include the $ symbol (default: true)
 * @returns Formatted currency string
 */
export const formatCurrency = (
  value: number | string | null | undefined,
  includeSymbol: boolean = true
): string => {
  // Handle null or undefined values
  if (value === null || value === undefined) {
    return includeSymbol ? "$0" : "0";
  }

  const numValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numValue)) {
    return includeSymbol ? "$0" : "0";
  }

  // Use toLocaleString with Colombian locale
  const formatted = numValue.toLocaleString("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return includeSymbol ? `$${formatted}` : formatted;
};
